import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCaretDown = () => {
  return (
    <g>
      <path d="M13.254 4c.19.001.38.088.526.26.267.316.29.81.073 1.158l-.073.1L8.53 11.74l-.084.086a.66.66 0 0 1-.901-.007l-.076-.08L2.22 5.523l-.073-.1a1.024 1.024 0 0 1 0-1.058l.073-.1.084-.085a.674.674 0 0 1 .446-.175V4h10.504z" />
    </g>
  );
};

export default withIcon(IconCaretDown);
